export function TextDetectionIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.2188 17.2129C21.7055 17.2129 22.0996 17.607 22.0996 18.0938V19.6562C22.0996 21.0038 21.0038 22.0996 19.6562 22.0996H18.0938C17.607 22.0996 17.2129 21.7055 17.2129 21.2188C17.2129 20.732 17.607 20.3379 18.0938 20.3379H19.6562C20.0318 20.3379 20.3379 20.0318 20.3379 19.6562V18.0938C20.3379 17.607 20.732 17.2129 21.2188 17.2129Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M2.78125 17.2129C3.26796 17.2129 3.66211 17.607 3.66211 18.0938V19.6562C3.66211 20.0318 3.9682 20.3379 4.34375 20.3379H5.90625C6.39296 20.3379 6.78711 20.732 6.78711 21.2188C6.78711 21.7055 6.39296 22.0996 5.90625 22.0996H4.34375C2.99618 22.0996 1.90039 21.0038 1.90039 19.6562V18.0938L1.9043 18.0039C1.94929 17.5594 2.32486 17.2129 2.78125 17.2129Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M5.90625 1.90039L5.99609 1.9043C6.44061 1.94929 6.78711 2.32486 6.78711 2.78125C6.78711 3.26796 6.39296 3.66211 5.90625 3.66211H4.34375C3.9682 3.66211 3.66211 3.9682 3.66211 4.34375V5.90625C3.66211 6.39296 3.26796 6.78711 2.78125 6.78711C2.29454 6.78711 1.90039 6.39296 1.90039 5.90625V4.34375L1.91309 4.09375C2.03869 2.8632 3.08058 1.90039 4.34375 1.90039H5.90625Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M19.6562 1.90039L19.9062 1.91309C21.1368 2.03869 22.0996 3.08058 22.0996 4.34375V5.90625C22.0996 6.39296 21.7055 6.78711 21.2188 6.78711C20.732 6.78711 20.3379 6.39296 20.3379 5.90625V4.34375C20.3379 3.9682 20.0318 3.66211 19.6562 3.66211H18.0938C17.607 3.66211 17.2129 3.26796 17.2129 2.78125C17.2129 2.29454 17.607 1.90039 18.0938 1.90039H19.6562Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M15.4261 5.90039L15.516 5.9043C15.9605 5.94929 16.307 6.32486 16.307 6.78125V8.34375C16.307 8.83046 15.9129 9.22461 15.4261 9.22461C14.9394 9.22461 14.5453 8.83046 14.5453 8.34375V7.66211H13.182V12.1504H13.8636C14.3504 12.1504 14.7445 12.5445 14.7445 13.0312C14.7445 13.518 14.3504 13.9121 13.8636 13.9121H10.7386C10.2519 13.9121 9.85779 13.518 9.85779 13.0312C9.85779 12.5445 10.2519 12.1504 10.7386 12.1504H11.4203V7.66211H10.057V8.34375C10.057 8.83046 9.66286 9.22461 9.17615 9.22461C8.68943 9.22461 8.29529 8.83046 8.29529 8.34375V6.78125L8.29919 6.69141C8.34419 6.24689 8.71976 5.90039 9.17615 5.90039H15.4261Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M17.2812 16.1844C17.768 16.1844 18.1621 16.5786 18.1621 17.0653C18.1621 17.552 17.768 17.9462 17.2812 17.9462H6.78125C6.29454 17.9462 5.90039 17.552 5.90039 17.0653C5.90039 16.5786 6.29454 16.1844 6.78125 16.1844H17.2812Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </svg>
  );
}
